import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19.4141 13L18.4141 14H19C21.7614 14 24 16.2386 24 19C24 21.7614 21.7614 24 19 24C16.2386 24 14 21.7614 14 19V18H16V19C16 20.6569 17.3431 22 19 22C20.6569 22 22 20.6569 22 19C22 17.3431 20.6569 16 19 16H18.4141L19.4141 17L18 18.4141L14.5859 15L18 11.5859L19.4141 13Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21.5 10.9277C20.718 10.6513 19.8767 10.5 19 10.5C14.8579 10.5 11.5 13.8579 11.5 18L11.5098 18.3857C11.5878 19.9259 12.132 21.3423 13.002 22.5H2.5V1.5H21.5V10.9277ZM7 13H12V11H7V13ZM7 9H17V7H7V9Z"}}]};

const DocumentUpdateFilled = Vue.extend<IconProps>({
  name: 'DocumentUpdateFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'document-update-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default DocumentUpdateFilled;
